/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Confirm_DispatchInputs */

const en_delivery_board_confirm_dispatch = /** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Dispatch`)
};

const es_delivery_board_confirm_dispatch = /** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar Despacho`)
};

const fr_delivery_board_confirm_dispatch = /** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l'envoi`)
};

const de_delivery_board_confirm_dispatch = /** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand bestätigen`)
};

const id_delivery_board_confirm_dispatch = /** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi Pengiriman`)
};

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const ja_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const zh_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const ar_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const it_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const ru_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const pt_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/** @type {(inputs: Delivery_Board_Confirm_DispatchInputs) => LocalizedString} */
const ko_delivery_board_confirm_dispatch = en_delivery_board_confirm_dispatch;

/**
* | output |
* | --- |
* | "Confirm Dispatch" |
*
* @param {Delivery_Board_Confirm_DispatchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_confirm_dispatch = /** @type {((inputs?: Delivery_Board_Confirm_DispatchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Confirm_DispatchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_confirm_dispatch(inputs)
	if (locale === "es") return es_delivery_board_confirm_dispatch(inputs)
	if (locale === "fr") return fr_delivery_board_confirm_dispatch(inputs)
	if (locale === "de") return de_delivery_board_confirm_dispatch(inputs)
	if (locale === "ja") return ja_delivery_board_confirm_dispatch(inputs)
	if (locale === "zh") return zh_delivery_board_confirm_dispatch(inputs)
	if (locale === "ar") return ar_delivery_board_confirm_dispatch(inputs)
	if (locale === "id") return id_delivery_board_confirm_dispatch(inputs)
	if (locale === "it") return it_delivery_board_confirm_dispatch(inputs)
	if (locale === "ru") return ru_delivery_board_confirm_dispatch(inputs)
	if (locale === "pt") return pt_delivery_board_confirm_dispatch(inputs)
	return ko_delivery_board_confirm_dispatch(inputs)
});